import { render, staticRenderFns } from "./SidebarSearchFilters.vue?vue&type=template&id=37117dea&scoped=true&"
import script from "./SidebarSearchFilters.vue?vue&type=script&lang=js&"
export * from "./SidebarSearchFilters.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSearchFilters.vue?vue&type=style&index=0&id=37117dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37117dea",
  null
  
)

export default component.exports